import { z } from "zod";

/// People person page tabs. `board` is the existing 1:1 relationship board
/// (Overview). `details` is the employee record (Details).
export const PEOPLE_DETAIL_TABS = ["board", "details"] as const;
export type PeopleDetailTab = (typeof PEOPLE_DETAIL_TABS)[number];

/// Drill-in ids on the Details tab. Files and Activity stay off this list
/// until those modules exist (EPD-FR-016).
export const DETAILS_SECTIONS = ["job", "time", "pay", "claims", "performance"] as const;
export type DetailsSection = (typeof DETAILS_SECTIONS)[number];

export const peopleDetailSearchSchema = z
  .object({
    tab: z.enum(PEOPLE_DETAIL_TABS).default("board").catch("board"),
    section: z.enum(DETAILS_SECTIONS).optional().catch(undefined),
  })
  .strict()
  .transform((search) => (search.tab === "board" ? { ...search, section: undefined } : search));
export type PeopleDetailSearch = z.infer<typeof peopleDetailSearchSchema>;
